module.exports = __webpack_public_path__ + "static/img/2.763b255.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TechnicalSupport/equipment/Grinding/2.png
// module id = 9Dj+
// module chunks = 13